import React, { useState } from "react";
import PropTypes from "prop-types";
import { addClient, updateClient } from "../services/firestore";

// PCS Admin React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

const ClientForm = ({ initialValues = {}, onSaved }) => {
  const [formData, setFormData] = useState({
    nombre: initialValues.nombre || "",
    email: initialValues.email || "",
    telefono: initialValues.telefono || "",
    direccion: initialValues.direccion || "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nombre.trim()) {
      newErrors.nombre = "El nombre es requerido";
    }
    if (!formData.email.trim()) {
      newErrors.email = "El email es requerido";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "El email no es válido";
    }
    if (!formData.telefono.trim()) {
      newErrors.telefono = "El teléfono es requerido";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      const clientData = {
        ...formData,
        created_at: new Date(),
      };

      if (initialValues.id) {
        await updateClient(initialValues.id, clientData);
      } else {
        await addClient(clientData);
      }

      if (!initialValues.id) {
        setFormData({
          nombre: "",
          email: "",
          telefono: "",
          direccion: "",
        });
      }

      if (onSaved) {
        onSaved();
      }
    } catch (error) {
      console.error("Error al guardar el cliente:", error);
      setErrors({
        submit: "Error al guardar el cliente. Por favor, intente nuevamente.",
      });
    }
  };

  return (
    <MDBox
      component="form"
      onSubmit={handleSubmit}
      sx={{
        "& .MuiTextField-root": { mb: 2 },
        "& .MuiButton-root": { mt: 1 },
      }}
    >
      <MDInput
        fullWidth
        label="Nombre"
        name="nombre"
        value={formData.nombre}
        onChange={handleChange}
        error={!!errors.nombre}
        helperText={errors.nombre}
        required
      />

      <MDInput
        fullWidth
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        error={!!errors.email}
        helperText={errors.email}
        required
      />

      <MDInput
        fullWidth
        label="Teléfono"
        name="telefono"
        value={formData.telefono}
        onChange={handleChange}
        error={!!errors.telefono}
        helperText={errors.telefono}
        required
      />

      <MDInput
        fullWidth
        label="Dirección"
        name="direccion"
        value={formData.direccion}
        onChange={handleChange}
        multiline
        rows={2}
      />

      {errors.submit && (
        <MDTypography variant="caption" color="error" fontWeight="light">
          {errors.submit}
        </MDTypography>
      )}

      <MDButton variant="gradient" color="success" type="submit" fullWidth>
        {initialValues.id ? "Actualizar" : "Agregar"}
      </MDButton>
    </MDBox>
  );
};

ClientForm.propTypes = {
  initialValues: PropTypes.shape({
    id: PropTypes.string,
    nombre: PropTypes.string,
    email: PropTypes.string,
    telefono: PropTypes.string,
    direccion: PropTypes.string,
  }),
  onSaved: PropTypes.func,
};

export default ClientForm; 